import { REQUEST_START, REQUEST_SUCCESS } from "../../../middlewares/api/actions";
import { getCurrentNodeConfig } from "../../../middlewares/current-node-config/middleware";
import {
  CODELIST_ORDER_ANNOTATION_KEY,
  SDMX_JSON_CODELIST_ITEMS_KEY,
  getItemSchemeFromSdmxJsonFactory,
  getSdmxStructuresFromSdmxJson
} from "../../../utils/sdmxJson";
import {
  ANNOTATIONS_FORM_DATAFLOW_BUILDER_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ,
  ANNOTATIONS_FORM_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ,
  ANNOTATIONS_FORM_DEFAULT_FILTERS_HIDE_SELECTOR,
  ANNOTATIONS_FORM_DEFAULT_FILTERS_SHOW_SELECTOR
} from "./actions";

const defaultFilterModalReducer = (
  state = {
    selectedDimensionForDefaultFilterItemsSelector: null,
    itemsPageForDefaultFilterItemsSelector: null,
    itemsCountForDefaultFilterItemsSelector: null,
  },
  action
) => {
  switch (action.type) {
    case ANNOTATIONS_FORM_DEFAULT_FILTERS_SHOW_SELECTOR:
      return {
        ...state,
        itemsPageForDefaultFilterItemsSelector: null,
        itemsCountForDefaultFilterItemsSelector: null
      };

    case ANNOTATIONS_FORM_DEFAULT_FILTERS_HIDE_SELECTOR:
      return {
        ...state,
        itemsPageForDefaultFilterItemsSelector: null,
        itemsCountForDefaultFilterItemsSelector: null
      };


    case REQUEST_START:
      switch (action.label) {
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case ANNOTATIONS_FORM_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ:
          return {
            ...state,
            itemsPageForDefaultFilterItemsSelector: getItemSchemeFromSdmxJsonFactory(
              SDMX_JSON_CODELIST_ITEMS_KEY,
              getCurrentNodeConfig(action).annotations,
              CODELIST_ORDER_ANNOTATION_KEY
            )(getSdmxStructuresFromSdmxJson(action.response)[0]).codes || [],
            itemsCountForDefaultFilterItemsSelector: Number(action.header["x-total-count"])
          };
        case ANNOTATIONS_FORM_DATAFLOW_BUILDER_DEFAULT_FILTERS_DIMENSIONS_ITEMS_READ:

          const itemsPage = getItemSchemeFromSdmxJsonFactory(
            SDMX_JSON_CODELIST_ITEMS_KEY,
            getCurrentNodeConfig(action).annotations,
            CODELIST_ORDER_ANNOTATION_KEY
          )(getSdmxStructuresFromSdmxJson(action.response[0])[0]).codes || [];

          const filteredCodes = action.response[1].Data.map(row => row[action.colName]);

          return {
            ...state,
            itemsPageForDefaultFilterItemsSelector:
              itemsPage.filter(({ id }) =>
                filteredCodes.includes(id))
          };

        default:
          return state;
      }
    default:
      return state;
  }
};

export default defaultFilterModalReducer;